// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"b96f1726","513":"44d19e5e","703":"19271eed","787":"0abcaa8d"}[chunkId] + ".chunk.js";
};